'use client';
import type {
  FaqCategoriesType,
  Faqs as FaqsType,
  PaginationResponse,
} from '@/types';

import { useSearchParams } from 'next/navigation';

import Faqs from '../Faqs';
import { FaqCategories, FaqSearch } from '..';

import { Box, Container, Pagination } from '@/components';

const ParentFaq: React.FC<{
  faqs: PaginationResponse<FaqsType>;
  categories: FaqCategoriesType[];
}> = ({ faqs, categories }) => {
  const searchParams = useSearchParams();
  const page = searchParams.get('page');
  return (
    <Container maxW="852px" mx="auto" pt={{ base: '10px', md: '50px' }}>
      <FaqSearch />
      <FaqCategories categories={categories} />
      <Faqs faqs={faqs.list} />
      <Box mt={{ base: '40px', lg: '90px' }}>
        {faqs.list.length > 0 && (
          <Pagination
            isLoading={false}
            totalCount={faqs.pagination.total}
            siblingCount={1}
            currentPage={Number(page) || 1}
            pageSize={10}
          />
        )}
      </Box>
    </Container>
  );
};
export default ParentFaq;
